import React from 'react';
import {Link} from "react-router-dom";

const CallToAction = () => {
    return (
        <section className="py-16 sm:py-24 relative flex justify-center items-center mx-2">
            <div
                className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto flex flex-col justify-center items-center">
                <div
                    className="w-full items-center text-center">
                    <div className="w-full flex flex-col justify-center items-center gap-10">
                        <div className="w-full flex flex-col justify-center items-center gap-3">
                            <h2 className="text-indigo-800 text-3xl sm:text-4xl font-semibold leading-normal">
                                Bạn cần tư vấn để nắm bắt xu hướng mới nhất, liên hệ Timo ngay!
                            </h2>
                            <p className="font-OpenSans text-gray-700 text-base font-normal leading-relaxed">
                                Liên hệ ngay để nhận tư vấn và khẳng định dấu ấn thương hiệu với chất liệu vải cao cấp từ Timo.
                            </p>
                        </div>
                        <Link
                            to="/wishlist"
                            className="sm:w-fit w-full group px-3.5 py-2 bg-[#D4AF37] hover:bg-indigo-800 transition-all duration-700 ease-in-out flex justify-center items-center">
                    <span
                        className="px-1.5 tracking-tight text-white text-base font-semibold leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                        Liên hệ
                    </span>
                            <svg className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                                 xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                 fill="none">
                                <path d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996" stroke="#FFFFFF"
                                      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;